import { Entry } from '../Entry'

export function Entry20250311() {
  return (
    <Entry title="2025 Mar 11 - v3.10.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17459/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
